export default __webpack_public_path__ + "static/media/close-orange.4e6830cf.svg";